import FreelanceBudget from ".";

export const freelanceBudgetRoutes = () => [
  {
    path: "/admin/freelance-budgets",
    component: FreelanceBudget,
    layout: "admin",
    routeType: "admin",
    title: "Freelance Management",
  },
];
